import React, {useContext} from "react";

export const Lotto5Context = React.createContext();

export const useLotto5 = () => useContext(Lotto5Context);